module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/growth-opportunities.json
// module id = 416
// module chunks = 56903047592724